import { AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTableFilterType, AimsCommonTablePermissions, TableRowUpdate, TableRowDelete } from '@aims/common-components';
import { Component, Input, OnInit } from '@angular/core';
import { Observable, PartialObserver } from 'rxjs';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { FacManufacturers } from 'src/models';

@Component({
  selector: 'aims-config-manufacturers',
  templateUrl: './config-manufacturers.component.html',
  styleUrls: ['./config-manufacturers.component.css'],
  providers: [ MainGridService ],
})
export class ConfigManufacturersComponent implements OnInit {
  resources: Observable<any>
  initialTableObject = new FacManufacturers()
  header: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'manufacturer', label: 'Manf Name', type: AimsCommonTableHeaderType.STRING },
  ]

  @Input() permissionNeeded: number;

  tablePermissions: Observable<AimsCommonTablePermissions>;

  constructor(
    public permissions: PermissionsService,
    public mainGridService: MainGridService<any>,
  ) {
    this.resources = this.mainGridService.getAll('Facilities/GetManufacturers', 'Facilities/SaveManufacturer', 'Facilities/DeleteManufacturer');
  }

  handleRowUpdate(update: TableRowUpdate): void {
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe())
  }

  handleRowAdd(update: TableRowUpdate): void {
    this.mainGridService.add(update.newRow).subscribe(update.handleSubscribe())
  }

  handleRowDelete(deleted: TableRowDelete) {
    const row = deleted.row as FacManufacturers;
    this.mainGridService.delete(row.manufacturerId, 'manufacturerId', deleted.index).subscribe(deleted.handleSubscribe());
  }

  ngOnInit(): void {
    this.tablePermissions = this.permissions.getDataGridPerms$(this.permissionNeeded, { export: false, delete: true });
  }
}
